import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FleetChargingFigureService } from 'src/app/_services/fleet-charging-figure.service';
import { VehicleChargingInsightsService } from 'src/app/_services/vehicle-charging-insights.service';
import { LoadingEntity} from '@inst-iot/bosch-angular-ui-components';
import { VehicleInfoService } from 'src/app/_services/vehicle-info.service';
import { DatePipe } from '@angular/common';
import { sortRbTableData } from 'src/app/_shared/utils/sort-utils';

@Component({
  selector: 'app-charging-vehicles',
  templateUrl: './charging-vehicles.component.html',
  styleUrls: ['./charging-vehicles.component.scss']
})
export class ChargingVehiclesComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() compareToFleet!: boolean;
  @Input() selectedVehicles: any;
  @Input() fleetId: string[] = [];
  deviceSerialNumber!: any[];
  currentVehicleData: any;
  filteredVehiclesData: any[] = [];
  stateOfChargeEventsDatapoints: any = {};
  stateOfChargeDatapoints: any = {};
  dataLoading: boolean = false;
  errorMessageSocEvents: boolean = false;
  dataLoadingSocEvents: boolean = false;
  errorMessageSoc: boolean = false;
  dataLoadingSoc: boolean = false;
  vehiclesChargingInsightsDataPoint: any;
  loader = new LoadingEntity;
  readonly sortData = sortRbTableData;

  constructor(
    private readonly vehicleChargingInsightsService: VehicleChargingInsightsService,
    private readonly fleetChargingFigureService: FleetChargingFigureService,
    private readonly vehicleInfoService: VehicleInfoService,
    private readonly datePipe: DatePipe
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataLoading = true;
    this.deviceSerialNumber = this.selectedVehicles.map((vehicle: { batteryIdentifier: any; }) => vehicle.batteryIdentifier);
    this.vehicleChargingInsightsService.getCurrentChargingInsights(this.deviceSerialNumber).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (data: any) => {
          this.vehiclesChargingInsightsDataPoint = data;
          this.currentVehicleData = this.selectedVehicles.map((vehicle: { batteryIdentifier: string; name: string; batteryId: string }) => ({
            ...data[vehicle.batteryIdentifier],
            vehicleName: vehicle.name,
            batteryId: vehicle.batteryId,
            batteryIdentifier: vehicle.batteryIdentifier
          }));
          this.vehicleInfoService.getCurrentVehicleInfo(this.deviceSerialNumber).pipe(takeUntil(this.unsubscribe$)).subscribe(
            {
              next: (data: any) => {
                this.currentVehicleData = this.currentVehicleData.map((vehicle: any) => {
                  const deviceData = data[vehicle.batteryIdentifier];
                  return {
                    ...vehicle,
                    timeWindowsStart: deviceData?.timeWindowsStart ?? null,
                    timestamp: deviceData?.timestamp ?? null
                  };
                });
              },
              error: (error) => {
                console.error('Error fetching Current Vehicle Info data:', error);
              }
            }
          )
        },
        error: (error) => {
          console.error('Error fetching Charging Insights data:', error);
          this.dataLoading = false;
        },
        complete: () => {
          this.dataLoading = false;
        }
      }
    );

    // API request for Initial/End State of Charge
    this.dataLoadingSoc = true;
    this.errorMessageSoc = false;
    this.fleetChargingFigureService.getStateOfChargeFleet(this.fleetId).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.stateOfChargeDatapoints = datapoints;
        },
        error: (error) => {
          console.error('Error fetching State of Charge Fleet data:', error);
          this.dataLoadingSoc = false;
          this.errorMessageSoc = true;
        },
        complete: () => {
          this.dataLoadingSoc = false;
        }
      }
    )

    // API request for Low/High State of Charge Events
    this.dataLoadingSocEvents = true;
    this.errorMessageSocEvents = false;
    this.fleetChargingFigureService.getStateOfChargeEventsFleet(this.fleetId).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.stateOfChargeEventsDatapoints = datapoints;
        },
        error: (error) => {
          console.error('Error fetching State of Charge Events Fleet data:', error);
          this.dataLoadingSocEvents = false;
          this.errorMessageSocEvents = true;
        },
        complete: () => {
          this.dataLoadingSocEvents = false;
        }
      }
    )

  }

  formatDateWithNbsp(date: string | Date | null | undefined): string {
    if (!date) return 'N/A';
    const formatted = this.datePipe.transform(date, 'dd MMM yyyy');
    return formatted ? formatted.replace(/ /g, '&nbsp;') : 'N/A';
  }
}
